import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0025aac6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Generator", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExportRender = _resolveComponent("ExportRender")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", null, "Available slots: " + _toDisplayString(_ctx.slots) + " / 3", 1),
    _createElementVNode("div", null, "Total renders: " + _toDisplayString(_ctx.queueElements.length), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.queueElements, (queueElement, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createVNode(_component_ExportRender, { queueElement: queueElement }, null, 8, ["queueElement"])
      ]))
    }), 128))
  ], 64))
}